import { render, staticRenderFns } from "./PendingReview.vue?vue&type=template&id=9a15b9d8&scoped=true&"
import script from "./PendingReview.vue?vue&type=script&lang=js&"
export * from "./PendingReview.vue?vue&type=script&lang=js&"
import style0 from "./PendingReview.vue?vue&type=style&index=0&id=9a15b9d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a15b9d8",
  null
  
)

export default component.exports